//TODO: REC-9815 - use uuid library instead of regex pattern
/**
 * The below regex pattern is extracted from analytics-ui
 * https://bitbucket.org/inindca/analytics-ui/src/bc15b8dce98573f9ec60eb4e4a339bcda4019598/app/utils/guid.ts#lines-2
 */
const UUID_PATTERN =
    /(^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i;

/**
 * Validates if a string is a valid UUID.
 * @param {string} uuid - The string to validate
 * @returns {boolean} - True if the string is a valid UUID, false otherwise
 */
function isValidUuid(uuid) {
    if (!uuid) {
        return false;
    }
    return UUID_PATTERN.test(uuid);
}

export default {
    isValidUuid: isValidUuid,
};
